import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import I18n from 'i18n-js'

import LinkChild from '@src/lib/LinkChild'
import useModalState from '@src/lib/useModalState'

import manageBrandsPaths from './manageBrandsPaths'
import SuggestBrandsCard from './SuggestBrandsCard'

const SuggestBrands: React.FC<React.PropsWithChildren> = (props) => {
  const params = manageBrandsPaths.index.useParams()
  const { isOpen, openModal, closeModal } = useModalState(false)

  return (
    <>
      <SuggestBrandsCard onDidSubmit={openModal} />
      <Dialog open={isOpen} onClose={closeModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          {I18n.t('manageBrands.suggestBrandsPage.requestSentSuccessTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {I18n.t('manageBrands.suggestBrandsPage.requestSentSuccessMessage')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <span>
            <Button variant="outlined" onClick={() => closeModal()}>
              {I18n.t('shared.close')}
            </Button>
          </span>
          <span>
            <LinkChild
              to={manageBrandsPaths.index.build({
                brandSlug: params.brandSlug,
                retailerAccountSlug: params.retailerAccountSlug,
                action: 'add',
              })}
            >
              <Button color="primary" variant="contained">
                {I18n.t('manageBrands.addBrands')}
              </Button>
            </LinkChild>
          </span>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default SuggestBrands
